import * as actionTypes from '../consts/actionTypes';

const initialState = {
    activities: [],
    msgError: ''
};

export default function activitiesReducer(state = initialState, action) {
    const DEFAULT = { ...state };
    const ACTIONS = {
        [actionTypes.SUCCESS_GET_ALL_ACTIVITIES]: responseToReturn(),
        [actionTypes.FAILURE_GET_ALL_FAILURE]: responseToReturn()
    };
    function responseToReturn() {
        let res = { ...state };
        if (action.response) {
            res = { ...state, activities: action.response.data, msgError: action.message };
        }
        if (action.message) {
            res = { ...state, msgError: action.message };
        }
        return res;
    }

    let receiveAction = DEFAULT;

    if (ACTIONS[action.type] !== undefined) {
        receiveAction = ACTIONS[action.type];
    }

    return receiveAction;
}